import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccessRole, ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormGroupErrorMessageComponent, ICustomTable, IHeader, LoadingPanelService, LocalService, noWhitespaceValidator, Utils } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SecPermisoService } from '../../../../services/database/secPermiso.service';
import { ISecPermisoAdmin, PermisoDto } from '../../../../shared/interfaces/database/seguridad';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PermisosHistoricoComponent } from './permisos-historico/permisos-historico.component';

@Component({
  selector: 'app-permisos',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CustomTableComponent, DialogModule, CustomTitle, FormGroupErrorMessageComponent, ConfirmPopupModule,
    ButtonModule, InputTextModule, PermisosHistoricoComponent
  ],
  templateUrl: './permisos.component.html'
})
export class PermisosComponent implements OnInit {

  customTable !: ICustomTable;
  role = AccessRole;
  trans: any = {};

  formTitle: string = "Nuevo";
  displayModal = false;
  _edit !: ISecPermisoAdmin | undefined;
  form !: FormGroup;

  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(PermisosHistoricoComponent) historico !: PermisosHistoricoComponent;
  private originalValues: any;

  constructor(private readonly _t: TranslateService, public readonly ls: LocalService, private readonly _sps: SecPermisoService, private readonly _fb: FormBuilder,
    private readonly _cs: ConfirmationService, private readonly _ms: MessageService, private readonly _lps: LoadingPanelService
  ) {
    this.configureForm();
  }

  ngOnInit(): void {
    this.translate();
    this.getPermisos();
  }

  get isNewForm() {
    return this._edit === undefined;
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      codificacion: this._t.get('common.codificacion'),
      descripcion: this._t.get('common.descripcion'),
      requiereRolSeguridad: this._t.get('msg.requiere-rol-seguridad'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      permiso: this._t.get('common.permiso'),
      permisos: this._t.get('common.permisos'),
      lcreado: this._t.get('_common.creado'),
      lactualizado: this._t.get('_common.actualizado'),
      leliminado: this._t.get('_common.eliminado'),
      warnSummary: this._t.get('form.msg.warn-summary'),
      completeCampos: this._t.get('form.msg.complete-campos'),
      estasSeguroEliminar: this._t.get('msg.estasSeguroEliminar'),
      tipo: this._t.get('common.tipo'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      tieneCargo: this._t.get('common.tieneCargo'),
      tieneUsuario: this._t.get('common.tieneUsuario'),
      nuevo: this._t.get('common.nuevo'),
    }));

    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'codificacion',
          header: this.trans.codificacion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipo',
          header: this.trans.tipo,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'hasCargo',
          header: this.trans.tieneCargo,
          sort: true,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'hasUsuario',
          header: this.trans.tieneUsuario,
          sort: true,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ISecPermisoAdmin) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          visible: {
            property: 'tipo',
            value: 'SEGURIDAD'
          },
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: ISecPermisoAdmin) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: ISecPermisoAdmin) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_SEC),
          },
          headerTooltip:{
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_SEC)
          }
        }
      ],
      settings: {
        table: {
          rows: 10,
        }
      }
    } as ICustomTable;
  }

  openNewModal() {
    this.formTitle = this.trans.nuevo + " " + this.trans.permiso;
    this._edit = undefined;
    this.resetForm();
    this.displayModal = true;
  }

  openEditModal(data: ISecPermisoAdmin) {
    this.formTitle = "Editar Rol";
    this._edit = data;
    this.resetForm();
    this.form.get('codificacion')?.setValue(data.codificacion);
    this.form.get('descripcion')?.setValue(data.descripcion);
    this.displayModal = true;
    this.originalValues = { ...this.form.value };
  }

  resetForm() {
    this.form.reset();
  }

  configureForm() {
    this.form = this._fb.group({
      codificacion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(255)]],
    });
  }

  deleteConfirmation(event: Event, data: ISecPermisoAdmin) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: this.trans.estasSeguroEliminar + this.trans.permiso + '?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deletePermiso(data.id)
      },
      reject: () => {

      }
    });
  }

  onSubmit() {
    if (this.form.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.form.invalid) {
      Utils.markAllFormControlsAsTouched(this.form);
      this._ms.add({ severity: 'warn', summary: this.trans.warnSummary, detail: this.trans.completeCampos });
      return;
    }

    let newValues = {
      codificacion: this.form.get('codificacion')?.value,
      descripcion: this.form.get('descripcion')?.value
    } as PermisoDto;

    if (this.isNewForm) {
      this.createPermiso(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updatePermiso(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

  abrirHistorial(data: ISecPermisoAdmin): void {
    this.historico.show(data.id);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }
  //#region API Calls
  getPermisos() {
    this._sps.getSecPermisoAdmin().subscribe({
      next: (data: ISecPermisoAdmin[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  private createPermiso(newPermiso: PermisoDto) {
    this._lps.show(true);
    this._sps.createPermiso(newPermiso).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.permiso + ' ' + this.trans.lcreado });
        this.getPermisos();
        this.displayModal = false;
      },
    });
  }

  private updatePermiso(permiso: PermisoDto) {
    if (!this._edit) return;
    this._lps.show(true);
    this._sps.updatePermiso(this._edit.id, permiso).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.permiso + ' ' + this.trans.lactualizado });
        this.getPermisos();
        this.displayModal = false;
      }
    });
  }

  private deletePermiso(id: number) {
    this._lps.show(true);
    this._sps.deletePermiso(id).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.permiso + ' ' + this.trans.leliminado });
        this.getPermisos();
      }
    });
  }
  //#endregion
}
